<template>
  <div class="footer-info">
    <p>
      Split The Bills is a trading name of STB2 Ltd, a company registered in
      England and Wales with company number 13017311, registered at 6th Floor, 1
      New Era Square, Sheffield, S2 4RB. VAT Number: 369812556
    </p>

    <p>© {{ new Date().getFullYear() }} STB2 Ltd. All rights reserved.</p>
  </div>
</template>

<script>
export default {
  name: "FooterInfo",
};
</script>

<style scoped lang="scss">
.footer-info {
  display: block;

  p {
    font-size: 13px;
    font-weight: $font-regular;
    color: $grey-darkish;
    margin: 0 0 10px 0;
    text-align: center;
  }

  @media (max-width: 768px) {
    padding-left: 30px;
    padding-right: 30px;
  }
}
</style>
